import React from "react";
import Head from "../components/Head";
import Foot from "../components/Foot";

function TermsandConditions() {
  return (
     <>
    <Head />
    
    
  {/* Start Breadcrumbs */}
  <section className="ak-about-hero-1">
    <img
      src="assets/img/bg/policy.jpg"
      className="about-hero-bg ak-bg object-cover"
      alt="..."
      data-swiper-parallax={1152}
    />
    <div className="container">
      <div className="about-hero-content">
        <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
          <p
            className="ak-section-subtitle animation-title"
            style={{ color: "white !important" }}
          >
            Policy
          </p>
          <h2
            className="ak-section-title animation-title"
            style={{ color: "white" }}
          >
            Terms and Conditions
          </h2>
        </div>
        <a href="/" className="back-btn" style={{ color: "white" }}>
          Home / Policy / Terms and Conditions
        </a>
      </div>
    </div>
  </section>
  {/* End Breadcrumbs */}
  {/* Start About  */}
  <div className="ak-height-125 ak-height-lg-80" />
  <section>
    <div className="about-us-content-bg">
      <div className="container">
        {/* <div className="about-us-content"> */}
         
     
     <div className="info-content">
  <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
    <p className="ak-section-subtitle animation-title">
      POLICY
    </p>
    <h2 className="ak-section-title animation-title">
      TERMS AND CONDITIONS
    </h2>

    <p className="ak-section-desp">
      Welcome to IFMEDU ACADEMY PRIVATE LIMITED (“we,” “our,” or “us”). These Terms and Conditions govern your use of our website <a href="https://ifmedu.in">https://ifmedu.in</a> and any services, courses, or content offered through it. By accessing or using our website, you agree to be bound by these Terms.
    </p>

    <p className="ak-section-desp">
      <strong>Company Information:</strong><br />
      IFMEDU ACADEMY PRIVATE LIMITED<br />
      VSK TOWER, Opp. TVS Junction,<br />
      Ernakulam, Kerala – 682019<br />
      Phone: +91 90486 48777<br />
      Email: enquiry@ifmedu.in
    </p>

    <p className="ak-section-desp">
      <strong>Eligibility:</strong><br />
      You must be at least 18 years old or accessing the site under the supervision of a parent or legal guardian. You agree to provide accurate and complete information when registering or enrolling in any course.
    </p>

    <p className="ak-section-desp">
      <strong>Course Enrollment & Payments:</strong><br />
      Enrollment is subject to availability and eligibility. Fees must be paid as outlined on the website or via official communication. We reserve the right to modify course content, schedules, or fees without prior notice. All payments are non-refundable unless otherwise stated.
    </p>

    <p className="ak-section-desp">
      <strong>Intellectual Property:</strong><br />
      All content on this website—including course materials, videos, graphics, and text—is the property of IFMEDU or its licensors. You may not reproduce or distribute any content without written consent.
    </p>

    <p className="ak-section-desp">
      <strong>Code of Conduct:</strong><br />
      Users must behave respectfully toward instructors, staff, and peers. Harassment, cheating, or misuse of resources may result in suspension or termination without refund.
    </p>

    <p className="ak-section-desp">
      <strong>Privacy Policy:</strong><br />
      Your use of the website is also governed by our <a href="https://ifmedu.in/privacy-policy">Privacy Policy</a>, which explains how we collect and use your personal information.
    </p>

    <p className="ak-section-desp">
      <strong>Limitation of Liability:</strong><br />
      IFMEDU is not liable for any damages arising from your use of the website or participation in any course. We do not guarantee job placement or certification recognition unless explicitly stated.
    </p>

    <p className="ak-section-desp">
      <strong>Third-Party Links:</strong><br />
      Our website may contain links to third-party sites. We are not responsible for their content or privacy practices.
    </p>

    <p className="ak-section-desp">
      <strong>Modifications to Terms:</strong><br />
      We may update these Terms at any time. Changes will be posted on this page. Continued use of the site implies acceptance of the revised Terms.
    </p>

    <p className="ak-section-desp">
      <strong>Governing Law:</strong><br />
      These Terms are governed by the laws of India. Disputes shall be subject to the courts in Ernakulam, Kerala.
    </p>

    <p className="ak-section-desp">
      <strong>Contact Us:</strong><br />
      For questions or concerns, contact us at:<br />
      📧 enquiry@ifmedu.in<br />
      📞 +91 90486 48777
    </p>
  </div>
</div>


        {/* </div> */}
        <div className="ak-height-125 ak-height-lg-80" />
      </div>
      <img className="aboutus" src="assets/img/bg/aboutus.png" alt="..." />
    </div>
  </section>
  {/* End About  */}




    <Foot />
    </>
  )
}

export default TermsandConditions